export const AdminProposalTracking = {
  AdminProposalTracking: 
  {
    permissionsId:'d2384773-8eec-4cd2-0089-08dd03ecea2b',
    permissionsName:'Admin Proposal Tracking' , 
    componentsId:null,
    components:null
  }
} ;
